import {UPDATE_UNDO_REDO, UNDO, REDO} from "../constants/action-types";

export default (
  undoRedo = {
    canUndo: false,
    canRedo: false
  },
  action
) => {
  const {type, payload} = action;

  switch (type) {
    case UPDATE_UNDO_REDO:
      return {...undoRedo, ...payload};

    case UNDO:
      return {...undoRedo, ...payload};

    case REDO:
      return {...undoRedo, ...payload};
  }

  return undoRedo;
};
